import { render, staticRenderFns } from "./SignUpPageRepresentativeUser.vue?vue&type=template&id=ee48a0e6&"
import script from "./SignUpPageRepresentativeUser.vue?vue&type=script&lang=js&"
export * from "./SignUpPageRepresentativeUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports